import { APP_BUILD_ID } from "./buildMeta";

export const GROUP_COLORS = {
    "a": { bg: "#4FC3F7", text: "#fff" },
    "b": { bg: "#81C784", text: "#fff" },
    "c": { bg: "#CE93D8", text: "#fff" },
    "dead": { bg: "#EF9A9A", text: "#fff" },
    "new": { bg: "#FFB74D", text: "#fff" },
    "query": { bg: "#9E9E9E", text: "#fff" },
};

export const SUB_GROUP_OPTIONS = ["AQ", "BQ", "CQ", "NQ"];

export const SUB_GROUP_COLORS = {
    AQ: { bg: "#0277BD", text: "#fff" },
    BQ: { bg: "#2E7D32", text: "#fff" },
    CQ: { bg: "#6A1B9A", text: "#fff" },
    NQ: { bg: "#E65100", text: "#fff" },
};

export default {
    APP_BUILD_ID,
    /** '' = site root; '/subdir' if admin is hosted under a path (for version.json URL). */
    APP_DEPLOY_BASE_PATH: "",
    SERVER_API: `https://adminapi.vedicmeet.com/api`,
    // SERVER_API: `http://localhost:5000/api`,
    // SERVER_API: `https://micro-services.vedicmeet.com:8000/api`,
    CHAT_SERVER_API: `https://micro-services.vedicmeet.com:8001/api`,
    CHAT_SOCKET_SERVER: `https://chat-server.vedicmeet.com:8000`,
    AGORA_CREDS: {
        app_id: '12a528304cd745bd97407b091ac5d645'
    }
}
// export default {
//     SERVER_API: `http://192.168.1.22:8000/api`,
//     CHAT_SERVER_API: `http://192.168.1.22:8000/api`,
//     CHAT_SOCKET_SERVER: `https://micro-services.vedicmeet.com:8001`,
//     AGORA_CREDS: {
//         app_id: '12a528304cd745bd97407b091ac5d645'
//     }
// }